<app-vault-module-shell
  moduleLabel="Inicio"
  [accessDenied]="accessDenied()"
  [loadError]="loadError()"
  [loadErrorTitle]="loadErrorTitle()"
>
<section class="vault-dashboard">
  <app-page-header
    title="Inicio"
    subtitle="Resumen operativo y métricas según tu rol."
    icon="LayoutDashboard"
  />

  <section class="vault-dashboard__session" aria-label="Contexto de usuario">
    <p class="vault-dashboard__session-greeting">Hola, {{ userDisplayName() }}</p>
    <p class="vault-dashboard__session-role">{{ sessionSummary() }}</p>
  </section>

  @if (loading()) {
    <div class="vault-dashboard__skeleton" aria-busy="true">
      <lib-skeleton variant="rectangle" [height]="'120px'" />
      <lib-skeleton variant="rectangle" [height]="'120px'" />
      <lib-skeleton variant="rectangle" [height]="'120px'" />
    </div>
  } @else {
    <lib-gridcard [items]="gridItems()" [loading]="false" />

    @if (preservationMessages().length > 0) {
      <section class="vault-dashboard__preservation" aria-label="Mensajes informativos">
        <div class="vault-dashboard__preservation-inner">
          <div class="vault-dashboard__preservation-top">
            <span class="vault-dashboard__preservation-label">{{ preservationCarouselLabel() }}</span>
            @if (preservationMessages().length > 1) {
              <div class="vault-dashboard__preservation-dots" role="tablist" aria-label="Seleccionar mensaje">
                @for (m of preservationMessages(); track m.id; let idx = $index) {
                  <button
                    type="button"
                    class="vault-dashboard__preservation-dot"
                    [class.vault-dashboard__preservation-dot--active]="idx === preservationIndex()"
                    [attr.aria-selected]="idx === preservationIndex()"
                    (click)="selectPreservationSlide(idx)"
                  >
                    <span class="vault-dashboard__preservation-sr">{{ idx + 1 }}</span>
                  </button>
                }
              </div>
            }
          </div>
          @if (currentPreservationMessage(); as pm) {
            <h3 class="vault-dashboard__preservation-title">{{ pm.title }}</h3>
            <p class="vault-dashboard__preservation-body">{{ pm.message }}</p>
          }
        </div>
      </section>
    }

    @if (!stats()) {
      <lib-empty
        icon="LayoutDashboard"
        message="Sin métricas disponibles"
        description="No se recibieron estadísticas del servidor para tu perfil."
      />
    }

    <div class="vault-dashboard__panels">
      <article class="vault-dashboard__panel">
        <h2 class="vault-dashboard__panel-title">Actividad reciente</h2>
        @if (activityRows().length === 0) {
          <lib-empty
            icon="Activity"
            message="Sin actividad reciente"
            description="Cuando existan eventos recientes aparecerán aquí."
          />
        } @else {
          <ul class="vault-dashboard__list">
            @for (row of activityRows(); track $index) {
              <li>{{ formatActivity(row) }}</li>
            }
          </ul>
        }
      </article>

      <article class="vault-dashboard__panel">
        <h2 class="vault-dashboard__panel-title">Tareas pendientes</h2>
        @if (taskCards().length === 0) {
          <lib-empty
            icon="List"
            message="Sin tareas pendientes"
            description="No hay tareas asignadas en este momento."
          />
        } @else {
          <div class="vault-dashboard__tasks">
            @for (task of taskCards(); track task.id) {
              <article class="vault-dashboard__task-card">
                <header class="vault-dashboard__task-head">
                  <h3 class="vault-dashboard__task-title">{{ task.title }}</h3>
                  <span class="vault-dashboard__task-priority">{{ task.priorityLabel }}</span>
                </header>
                <p class="vault-dashboard__task-description">{{ task.description }}</p>
                <p class="vault-dashboard__task-meta">
                  Módulo: {{ task.moduleLabel }} · {{ task.whenLabel }}
                </p>
                @if (task.route.length) {
                  <a
                    class="vault-dashboard__task-link"
                    [routerLink]="task.route"
                    [queryParams]="task.queryParams"
                  >
                    {{ task.linkLabel }}
                  </a>
                }
              </article>
            }
          </div>
        }
      </article>
    </div>
  }
</section>
</app-vault-module-shell>
